import { Seo } from '../components/seo';
import { RequisitesCard } from '../components/requisites-card';
import { useLocale, useT } from '../i18n/locale-context';

/** /requisites — company legal + bank details (e-commerce disclosure). Public. */
export function Requisites() {
  const t = useT();
  const { locale } = useLocale();

  return (
    <div className="mx-auto max-w-[820px]">
      <Seo
        title={t('requisites.pageTitle')}
        description={t('requisites.subtitle')}
        canonical="/requisites"
        lang={locale}
      />

      <h1 className="mb-1 font-brand text-[24px] font-extrabold tracking-[-0.3px] text-ink">
        {t('requisites.pageTitle')}
      </h1>
      <p className="mb-6 text-[14px] text-ink-soft">{t('requisites.subtitle')}</p>

      <RequisitesCard />

      <p className="mt-6 text-[12.5px] leading-[1.6] text-ink-muted">{t('requisites.note')}</p>
    </div>
  );
}
